import classNames from "classnames";
import * as React from "react";
// import ProductDiscountSplash from "../product-discount-splash/product-discount-splash";
import ProductImage, { ProductImageProps } from "../product-image/product-image";
import Icon from "../icons/icon";
import { IProductTileChildProps, IProductTileProps } from "./product-tile";
import Tag from "../tag/tag";

interface IProductTileImageProps
    extends Pick<
            IProductTileProps,
            | "hasQuickView"
            | "imageSrcSet"
            | "imageFallbackSrc"
            | "url"
            | "target"
            | "title"
            // | "discount"
            | "status"
        >,
        Pick<ProductImageProps, "sizes">,
        IProductTileChildProps {
    detailsLabel?: string;
    hideStatus?: boolean;
    statusLabel?: string;
}

const ProductTileImage: React.FC<IProductTileImageProps> = ({
    hasQuickView,
    baseClass,
    url,
    target,
    title,
    imageSrcSet,
    imageFallbackSrc,
    sizes,
    // discount,
    detailsLabel,
    hideStatus,
    status,
    statusLabel,
    onClick
}) => {
    const imageBaseClasses = classNames(`${baseClass}__image-wrapper`, {
        [`${baseClass}__image-wrapper--hasQuickView`]: hasQuickView
    });

    const Image = () =>
        imageSrcSet ? (
            <ProductImage
                className="product-tile__image"
                srcSet={imageSrcSet}
                fallbackSrc={imageFallbackSrc}
                sizes={sizes || "200px"}
                alt={title}
            />
        ) : null;

    return hasQuickView ? (
        <div className={imageBaseClasses} onClick={onClick}>
            <Image />
            {/* {discount && <ProductDiscountSplash discount={discount} />} */}
            <button className={`${baseClass}__details-button`}>
                <Icon iconId="24_expand" className={`${baseClass}__details-icon`} />
                <span>{detailsLabel}</span>
            </button>
        </div>
    ) : (
        <a className={imageBaseClasses} href={url} target={target} onClick={onClick}>
            {!hideStatus && !!status && (
                <Tag className={`${baseClass}__status-tag`} type={status}>
                    {statusLabel}
                </Tag>
            )}
            <Image />
            {/* {discount && (
                <ProductDiscountSplash className="product-tile__image-discount-splash" discount={discount} />
            )} */}
        </a>
    );
};

export default React.memo(ProductTileImage);
